// Backend wraps unresolved i18n keys in `[[key]]`. Translate every occurrence
// using the active i18next instance, falling back to the bare key when the
// translation is missing so users still get readable text.
//
// 869d58e58: the backend sometimes appends extra context inside the same
// token, e.g. `[[api.item.badRequest.noStock: 0 Unidades]]`. The whole
// content is not a valid catalog key, so the direct lookup fails. In that
// case we split on the first ": ", try to translate the prefix, and keep
// the rest of the string as literal context.
const MISSING = '__SPORTTIA_TRANSLATE_PLACEHOLDERS_MISSING__';

export const translatePlaceholders = (
    text: string,
    t: (key: string, options?: { defaultValue?: string }) => string,
): string =>
    text.replace(/\[\[([^\]]+)\]\]/g, (_, content: string) => {
        const direct = t(content, { defaultValue: MISSING });
        if (direct !== MISSING) return direct;

        const colonIdx = content.indexOf(': ');
        if (colonIdx > 0) {
            const key = content.slice(0, colonIdx);
            const rest = content.slice(colonIdx + 2);
            const translated = t(key, { defaultValue: MISSING });
            if (translated !== MISSING) {
                return `${translated}: ${rest}`;
            }
        }

        return content;
    });
